var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PdfIcon = function (_a) {
    var width = _a.width, height = _a.height;
    return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", width: width, height: height }, { children: [_jsx("path", { fill: "#d32f2f", d: "M37,45H11c-1.657,0-3-1.343-3-3V6c0-1.657,1.343-3,3-3h19l10,10v29C40,43.657,38.657,45,37,45z" }), _jsx("path", { fill: "#f44336", d: "M40 13L30 13 30 3z" }), _jsx("path", { fill: "#b71c1c", d: "M30 13L40 23 40 13z" }), _jsx("path", { fill: "#fff", d: "M16 21H32V23H16zM16 25H32V27H16zM16 29H28V31H16z" }), _jsx("text", __assign({ x: "24", y: "37", fontFamily: "Arial, sans-serif", fontSize: "8", fontWeight: "bold", fill: "#fff", textAnchor: "middle" }, { children: "PDF" }))] })));
};
export default PdfIcon;
